"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FirstDayOfWeek", {
  enumerable: true,
  get: function get() {
    return _types.FirstDayOfWeek;
  }
});
exports.default = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _dropDown = _interopRequireDefault(require("@clayui/drop-down"));

var _form = require("@clayui/form");

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _shared = require("@clayui/shared");

var _react = _interopRequireDefault(require("react"));

var _DateNavigation = _interopRequireDefault(require("./DateNavigation"));

var _DayNumber = _interopRequireDefault(require("./DayNumber"));

var _DaysTable = _interopRequireDefault(require("./DaysTable"));

var _Helpers = require("./Helpers");

var _Hooks = require("./Hooks");

var _InputDate = _interopRequireDefault(require("./InputDate"));

var _TimePicker = _interopRequireDefault(require("./TimePicker"));

var _Weekday = _interopRequireDefault(require("./Weekday"));

var _WeekdayHeader = _interopRequireDefault(require("./WeekdayHeader"));

var _types = require("./types");

var _excluded = ["ariaLabels", "dateFormat", "disabled", "expanded", "firstDayOfWeek", "footerElement", "id", "initialExpanded", "initialMonth", "inputName", "months", "onExpandedChange", "onNavigation", "onValueChange", "placeholder", "range", "spritemap", "time", "timezone", "use12Hours", "useNative", "value", "weekdaysShort", "years", "yearsCheck"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DEFAULT_DATE_TIME = {
  hours: 12,
  milliseconds: 0,
  minutes: 0,
  seconds: 0
};
var NEW_DATE = new Date();
var TIME_FORMAT = 'HH:mm';
var TIME_FORMAT_12H = 'hh:mm aa';
/**
 * ClayDatePicker component.
 */

var ClayDatePicker = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$ariaLabels = _ref.ariaLabels,
      ariaLabels = _ref$ariaLabels === void 0 ? {
    buttonChooseDate: 'Choose date',
    buttonDot: 'Select current date',
    buttonNextMonth: 'Select the next month',
    buttonPreviousMonth: 'Select the previous month'
  } : _ref$ariaLabels,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'yyyy-MM-dd' : _ref$dateFormat,
      disabled = _ref.disabled,
      expanded = _ref.expanded,
      _ref$firstDayOfWeek = _ref.firstDayOfWeek,
      firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? _types.FirstDayOfWeek.Sunday : _ref$firstDayOfWeek,
      footerElement = _ref.footerElement,
      id = _ref.id,
      _ref$initialExpanded = _ref.initialExpanded,
      initialExpanded = _ref$initialExpanded === void 0 ? false : _ref$initialExpanded,
      _ref$initialMonth = _ref.initialMonth,
      initialMonth = _ref$initialMonth === void 0 ? NEW_DATE : _ref$initialMonth,
      inputName = _ref.inputName,
      _ref$months = _ref.months,
      months = _ref$months === void 0 ? ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'] : _ref$months,
      onExpandedChange = _ref.onExpandedChange,
      _ref$onNavigation = _ref.onNavigation,
      onNavigation = _ref$onNavigation === void 0 ? function () {} : _ref$onNavigation,
      _ref$onValueChange = _ref.onValueChange,
      onValueChange = _ref$onValueChange === void 0 ? function () {} : _ref$onValueChange,
      placeholder = _ref.placeholder,
      range = _ref.range,
      spritemap = _ref.spritemap,
      _ref$time = _ref.time,
      time = _ref$time === void 0 ? false : _ref$time,
      timezone = _ref.timezone,
      _ref$use12Hours = _ref.use12Hours,
      use12Hours = _ref$use12Hours === void 0 ? false : _ref$use12Hours,
      _ref$useNative = _ref.useNative,
      useNative = _ref$useNative === void 0 ? false : _ref$useNative,
      value = _ref.value,
      _ref$weekdaysShort = _ref.weekdaysShort,
      weekdaysShort = _ref$weekdaysShort === void 0 ? ['S', 'M', 'T', 'W', 'T', 'F', 'S'] : _ref$weekdaysShort,
      _ref$years = _ref.years,
      years = _ref$years === void 0 ? {
    end: NEW_DATE.getFullYear(),
    start: NEW_DATE.getFullYear()
  } : _ref$years,
      _ref$yearsCheck = _ref.yearsCheck,
      yearsCheck = _ref$yearsCheck === void 0 ? true : _ref$yearsCheck,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  /**
   * Indicates the current month rendered on the screen.
   */
  var _React$useState = _react.default.useState(function () {
    return (// Normalize the date to always set noon to avoid time zone problems
      // and to the 1st of the month.
      (0, _Helpers.setDate)(initialMonth, _objectSpread({
        date: 1
      }, DEFAULT_DATE_TIME))
    );
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentMonth = _React$useState2[0],
      setCurrentMonth = _React$useState2[1];
  /**
   * DaysSelected is a tuple that represents [startDate, endDate]
   * in the cases where We have a date range and when `range` property
   * is disabled we will just use the first element of the tuple(startDate)
   */


  var _useDaysSelected = (0, _Hooks.useDaysSelected)(initialMonth),
      _useDaysSelected2 = _slicedToArray(_useDaysSelected, 2),
      daysSelected = _useDaysSelected2[0],
      setDaysSelected = _useDaysSelected2[1];
  /**
   * Indicates the time selected by the user.
   */


  var _useCurrentTime = (0, _Hooks.useCurrentTime)(use12Hours),
      _useCurrentTime2 = _slicedToArray(_useCurrentTime, 2),
      currentTime = _useCurrentTime2[0],
      setCurrentTime = _useCurrentTime2[1];
  /**
   * An array of the weeks and days list for the current month
   */


  var _useWeeks = (0, _Hooks.useWeeks)(currentMonth, firstDayOfWeek),
      _useWeeks2 = _slicedToArray(_useWeeks, 2),
      weeks = _useWeeks2[0],
      setWeeks = _useWeeks2[1];
  /**
   * Flag to indicate if date is expanded. Uses an internal state value
   * if component is not controlled by props.
   */


  var _useInternalState = (0, _shared.useInternalState)({
    defaultName: 'initialExpanded',
    handleName: 'onExpandedChange',
    initialValue: initialExpanded,
    name: 'expanded',
    onChange: onExpandedChange,
    value: expanded
  }),
      _useInternalState2 = _slicedToArray(_useInternalState, 2),
      expandedValue = _useInternalState2[0],
      setExpandedValue = _useInternalState2[1];
  /**
   * Create a ref to store the datepicker DOM element
   */


  var dropdownContainerRef = _react.default.useRef(null);
  /**
   * Create a ref to store the datepicker DOM element
   */


  var triggerElementRef = _react.default.useRef(null);
  /**
   * Handles the change of the current month of the Date Picker
   * content and takes care of updating the weeks.
   */


  var changeMonth = function changeMonth(date) {
    var dateNormalized = (0, _Helpers.setDate)(date, _objectSpread({
      date: 1
    }, DEFAULT_DATE_TIME));
    setCurrentMonth(dateNormalized);
    onNavigation(dateNormalized); // It is not necessary to update the weeks when the native
    // date is enabled. Unnecessary rendering and processing.

    if (!useNative) {
      setWeeks(dateNormalized);
    }
  };
  /**
   * Handles the click on element of the day
   */


  var handleDayClicked = function handleDayClicked(date) {
    var _daysSelected = _slicedToArray(daysSelected, 2),
        startDate = _daysSelected[0],
        endDate = _daysSelected[1];

    var newDaysSelected;
    var daysSelectedToString;

    if (range) {
      if (startDate !== endDate) {
        newDaysSelected = [date, date];
      } else if (date < startDate) {
        newDaysSelected = [date, endDate];
      } else {
        newDaysSelected = [startDate, date];
      }

      daysSelectedToString = fromRangeToString(newDaysSelected, dateFormat);

      var _newDaysSelected = newDaysSelected,
          _newDaysSelected2 = _slicedToArray(_newDaysSelected, 2),
          newStartDate = _newDaysSelected2[0],
          newEndDate = _newDaysSelected2[1];

      if (newStartDate.getMonth() !== newEndDate.getMonth()) {
        changeMonth(startDate);
      }
    } else {
      newDaysSelected = [date, date];
      daysSelectedToString = (0, _Helpers.formatDate)(date, dateFormat);

      if (time) {
        daysSelectedToString = "".concat(daysSelectedToString, " ").concat(currentTime);
      }
    }

    setDaysSelected(newDaysSelected);
    onValueChange(daysSelectedToString, 'click');
  };
  /**
   * Control the value of the input propagating with the call
   * of `onValueChange` but does not change what the user types,
   * if a date is valid the month of the Date Picker is changed.
   */


  var inputChange = function inputChange(event) {
    var value = event.target.value;

    if (!value) {
      changeMonth(initialMonth);
      setDaysSelected([initialMonth, initialMonth]);

      if (time) {
        setCurrentTime('--', '--', undefined);
      }
    } else {
      var format = time ? "".concat(dateFormat, " ").concat(use12Hours ? TIME_FORMAT_12H : TIME_FORMAT) : dateFormat;

      var _fromStringToRange = fromStringToRange(value, format, NEW_DATE),
          _fromStringToRange2 = _slicedToArray(_fromStringToRange, 2),
          startDate = _fromStringToRange2[0],
          endDate = _fromStringToRange2[1];

      var yearFrom = startDate.getFullYear();
      var yearTo = endDate.getFullYear();
      var isValidYear = yearsCheck ? isYearWithinYears(yearFrom, years) && isYearWithinYears(yearTo, years) : true;

      if ((0, _Helpers.isValid)(startDate) && (0, _Helpers.isValid)(endDate) && isValidYear) {
        changeMonth(startDate);
        setDaysSelected([startDate, endDate]);

        if (time) {
          setCurrentTime(startDate.getHours(), startDate.getMinutes(), use12Hours ? (0, _Helpers.formatDate)(startDate, 'a') : undefined);
        }
      }
    }

    onValueChange(value, 'input');
  };
  /**
   * Changes selected date to the current date. The same happens when there
   * is no date selected.
   */


  var handleDotClicked = function handleDotClicked() {
    var _daysSelected2 = _slicedToArray(daysSelected, 2),
        endDate = _daysSelected2[1];

    changeMonth(initialMonth);
    var newDaysSelected = range && endDate < initialMonth ? [endDate, initialMonth] : [initialMonth, endDate];
    var dateFormatted;

    if (range) {
      dateFormatted = fromRangeToString(newDaysSelected, dateFormat);
    } else if (time) {
      dateFormatted = "".concat((0, _Helpers.formatDate)(initialMonth, dateFormat), " ").concat(setCurrentTime(initialMonth.getHours(), initialMonth.getMinutes(), use12Hours ? (0, _Helpers.formatDate)(initialMonth, 'a') : undefined));
    } else {
      dateFormatted = (0, _Helpers.formatDate)(initialMonth, dateFormat);
    }

    setDaysSelected(newDaysSelected);
    onValueChange(dateFormatted);
  };

  var handleTimeChange = function handleTimeChange(hours, minutes, ampm) {
    var _daysSelected3 = _slicedToArray(daysSelected, 1),
        day = _daysSelected3[0];

    if (hours === '--' && typeof minutes === 'number') {
      hours = 0;
    }

    if (minutes === '--' && typeof hours === 'number') {
      minutes = 0;
    }

    if (value) {
      var date = typeof hours === 'string' && typeof minutes === 'string' ? "".concat((0, _Helpers.formatDate)(day, dateFormat), " ").concat(hours, ":").concat(minutes) : (0, _Helpers.formatDate)((0, _Helpers.setDate)(day, {
        hours: hours,
        minutes: minutes
      }), "".concat(dateFormat, " ").concat(TIME_FORMAT));

      if (use12Hours) {
        date += " ".concat(ampm);
      }

      onValueChange(date, 'time');
    }

    setCurrentTime(hours, minutes, use12Hours ? ampm : undefined);
  };
  /**
   * Handles datepicker view
   */


  var handleCalendarButtonClicked = function handleCalendarButtonClicked() {
    return setExpandedValue(!expandedValue);
  };
  /**
   * Handle with the focus when it's outside of the component
   * In this case, forces the state of expanded to be false
   */


  var handleFocus = function handleFocus(event) {
    if (dropdownContainerRef.current && !dropdownContainerRef.current.contains(event.target) && triggerElementRef.current && !triggerElementRef.current.contains(event.target)) {
      setExpandedValue(false);
    }
  };

  _react.default.useEffect(function () {
    document.addEventListener('focus', handleFocus, true);
    return function () {
      document.removeEventListener('focus', handleFocus, true);
    };
  }, [handleFocus]);

  return /*#__PURE__*/_react.default.createElement(_shared.FocusScope, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker"
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.Group, {
    id: id,
    ref: triggerElementRef
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, null, /*#__PURE__*/_react.default.createElement(_InputDate.default, _extends({}, otherProps, {
    ariaLabel: ariaLabels.input,
    disabled: disabled,
    inputName: inputName,
    onChange: inputChange,
    placeholder: placeholder,
    ref: ref,
    useNative: useNative,
    value: value
  })), !useNative && /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupInsetItem, {
    after: true
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    "aria-label": ariaLabels.buttonChooseDate,
    className: "date-picker-dropdown-toggle",
    disabled: disabled,
    displayType: "unstyled",
    onClick: handleCalendarButtonClicked
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "calendar"
  }))))), !useNative && /*#__PURE__*/_react.default.createElement(_dropDown.default.Menu, {
    active: expandedValue,
    alignElementRef: triggerElementRef,
    className: "date-picker-dropdown-menu",
    onSetActive: setExpandedValue,
    ref: dropdownContainerRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-modal": "true",
    className: "date-picker-calendar",
    role: "dialog"
  }, /*#__PURE__*/_react.default.createElement(_DateNavigation.default, {
    ariaLabels: ariaLabels,
    currentMonth: currentMonth,
    disabled: disabled,
    months: months,
    onDotClicked: handleDotClicked,
    onMonthChange: changeMonth,
    spritemap: spritemap,
    years: years
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-calendar-body"
  }, /*#__PURE__*/_react.default.createElement(_WeekdayHeader.default, {
    firstDayOfWeek: firstDayOfWeek,
    weekdaysShort: weekdaysShort
  }, function (_ref2) {
    var key = _ref2.key,
        weekday = _ref2.weekday;
    return /*#__PURE__*/_react.default.createElement(_Weekday.default, {
      key: key,
      weekday: weekday
    });
  }), /*#__PURE__*/_react.default.createElement(_DaysTable.default, {
    weeks: weeks
  }, function (_ref3) {
    var day = _ref3.day,
        key = _ref3.key;
    return /*#__PURE__*/_react.default.createElement(_DayNumber.default, {
      day: day,
      daysSelected: daysSelected,
      disabled: disabled,
      key: key,
      onClick: handleDayClicked,
      range: range
    });
  })), (footerElement || time) && /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-calendar-footer"
  }, time && /*#__PURE__*/_react.default.createElement(_TimePicker.default, {
    currentTime: currentTime,
    disabled: disabled,
    onTimeChange: handleTimeChange,
    spritemap: spritemap,
    timezone: timezone,
    use12Hours: use12Hours
  }), !time && footerElement && _react.default.Children.only(footerElement({
    spritemap: spritemap
  })))))));
});

var RANGE_SEPARATOR = ' - ';

function isYearWithinYears(year, years) {
  return years.start <= year && year <= years.end;
}

function fromStringToRange(value, dateFormat, referenceDate) {
  var _value$split = value.split(RANGE_SEPARATOR),
      _value$split2 = _slicedToArray(_value$split, 2),
      startDateString = _value$split2[0],
      endDateString = _value$split2[1];

  var startDate = (0, _Helpers.parseDate)(startDateString, dateFormat, referenceDate);
  return [startDate, endDateString ? (0, _Helpers.parseDate)(endDateString, dateFormat, referenceDate) : startDate];
}

function fromRangeToString(range, dateFormat) {
  var _range = _slicedToArray(range, 2),
      startDate = _range[0],
      endDate = _range[1];

  return "".concat((0, _Helpers.formatDate)(startDate, dateFormat)).concat(RANGE_SEPARATOR).concat((0, _Helpers.formatDate)(endDate, dateFormat));
}

ClayDatePicker.displayName = 'ClayDatePicker';
var _default = ClayDatePicker;
exports.default = _default;